import { render, staticRenderFns } from "./AddAssistant.vue?vue&type=template&id=46fa8292&scoped=true"
import script from "./AddAssistant.vue?vue&type=script&lang=js"
export * from "./AddAssistant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fa8292",
  null
  
)

export default component.exports